import PropTypes from 'prop-types';
import { BsTrash } from 'react-icons/bs';

import Card from '#globalComponents/Card/Card';
import IconButton from '#globalComponents/IconButton/IconButton';
import Tag from '#globalComponents/Tag/Tag';

import { API_SCOPE_OPTIONS } from './constants';

const scopeLabel = (value) => API_SCOPE_OPTIONS.find((o) => o.value === value)?.label ?? value;

const formatDate = (iso) => (iso ? new Date(iso).toLocaleDateString('de-DE') : '—');

const ApiKeyListItem = ({ apiKey, onRevoke }) => {
	const isRevoked = apiKey.status === 'revoked';

	return (
		<Card className="flex items-start justify-between gap-4">
			<div className="min-w-0 space-y-2">
				<div className="flex min-w-0 items-center gap-2">
					<span className="truncate text-sm font-semibold text-text">{apiKey.name}</span>
					{isRevoked && <Tag label="Widerrufen" tone="warning" size="xs" />}
				</div>
				<code className="block font-mono text-sm text-bgBase-800">{apiKey.prefix}…</code>
				<div className="flex flex-wrap gap-1">
					{(apiKey.scopes ?? []).map((s) => (
						<Tag key={s} label={scopeLabel(s)} size="xs" />
					))}
				</div>
				<p className="text-xs text-bgBase-800">Zuletzt verwendet: {formatDate(apiKey.lastUsedAt)}</p>
			</div>
			{!isRevoked && (
				<IconButton
					icon={BsTrash}
					label="Schlüssel widerrufen"
					tone="danger"
					onClick={() => onRevoke(apiKey)}
				/>
			)}
		</Card>
	);
};

ApiKeyListItem.propTypes = {
	apiKey: PropTypes.shape({
		id: PropTypes.string.isRequired,
		name: PropTypes.string.isRequired,
		prefix: PropTypes.string.isRequired,
		scopes: PropTypes.arrayOf(PropTypes.string),
		status: PropTypes.string,
		lastUsedAt: PropTypes.string,
	}).isRequired,
	onRevoke: PropTypes.func.isRequired,
};

export default ApiKeyListItem;
